enum CueColour {
    DEFAULT
}

export default CueColour;